import { renderMarkdownAndSanitize } from "@/lib/markdown";

interface Props {
  text?: string;
}

export default function MinisiteCheckout({ text }: Props) {
  const sanitized = renderMarkdownAndSanitize(text);
  if (!sanitized) return null;

  return (
    <section className="h-52 rounded-2xl bg-card border flex items-center justify-center text-center">
      <div
        className="prose prose-sm dark:prose-invert max-w-none w-full overflow-hidden break-words p-5 text-card-foreground"
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </section>
  );
}
